import SvgIcon from '@mui/material_v7/SvgIcon';

import { IconProps } from './types';

const FacilityIcon = (props: IconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14" fill="currentColor">
      <path
        d="M0 12.4444V1.55556C0 1.12778 0.156667 0.761574 0.47 0.456944C0.783333 0.152315 1.16 0 1.6 0H6.4C6.84 0 7.21667 0.152315 7.53 0.456944C7.84333 0.761574 8 1.12778 8 1.55556V3.11111H14.4C14.84 3.11111 15.2167 3.26343 15.53 3.56806C15.8433 3.87269 16 4.23889 16 4.66667V12.4444C16 12.8722 15.8433 13.2384 15.53 13.5431C15.2167 13.8477 14.84 14 14.4 14H1.6C1.16 14 0.783333 13.8477 0.47 13.5431C0.156667 13.2384 0 12.8722 0 12.4444ZM1.6 12.4444H3.2V10.8889H1.6V12.4444ZM1.6 9.33333H3.2V7.77778H1.6V9.33333ZM1.6 6.22222H3.2V4.66667H1.6V6.22222ZM1.6 3.11111H3.2V1.55556H1.6V3.11111ZM4.8 12.4444H6.4V10.8889H4.8V12.4444ZM4.8 9.33333H6.4V7.77778H4.8V9.33333ZM4.8 6.22222H6.4V4.66667H4.8V6.22222ZM4.8 3.11111H6.4V1.55556H4.8V3.11111ZM8 12.4444H14.4V4.66667H8V6.22222H9.6V7.77778H8V9.33333H9.6V10.8889H8V12.4444ZM11.2 7.77778V6.22222H12.8V7.77778H11.2ZM11.2 10.8889V9.33333H12.8V10.8889H11.2Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
);

export default FacilityIcon;
